import { createWebHistory, createRouter } from "vue-router";
import axios from 'axios';
import routes from './routes';
import appConfig from "../../app.config";
import store from '@/state/store';
import { computed } from "vue";

const user = computed(() => store.state.user.user);

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
  linkActiveClass: 'active', // Clase activa para coincidencias parciales
  // linkExactActiveClass: 'exact-active' // Clase activa solo para coincidencias exactas
});

// // API based Authentication
// // Before each route evaluates...
// router.beforeEach(async (routeTo, routeFrom, next) => {
//   // console.log("beforeEach aqui checar si esta autenticado");
//   // console.log(routeTo);
//   const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
  
//   if (!authRequired) return next();
//   //console.log("OKI");
//   axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt'); // for all requests
//   // await axios.get('https://api-node.themesbrand.website/profile').then((data) => {
//   await axios.post('users/renew').then((data) => {
//     //  console.log("data:",data.data);
    
//     localStorage.setItem('user', JSON.stringify(data.data.user));    
//     localStorage.setItem('jwt', data.data.token);
//     // console.log(data.data.user);
//     store.dispatch('user/setLoggedUser', {user : data.data.user });
//     next();
//   }).catch((error) => {
// // console.log("error");
//     console.log(error);
// //console.log(error.response.status);
// //console.log(error.response.statusText);
//     next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
//   });
// });

router.beforeEach(async (routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
  const userRoleId = user.value.rolId
  // console.log("routeTo: ", routeTo, " authRequired: ", authRequired);
  if (!authRequired) return next();

  const currentToken = localStorage.getItem('jwt');
  // console.log("currentToken ", currentToken);
  if (!currentToken) {
    return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
  }

  console.log("a revisar roles para ", userRoleId);
  if (routeTo.meta.allowedRoles && !routeTo.meta.allowedRoles.includes(userRoleId)) {
      // console.log("vas pa tras");
      return next({ name: 'default' }) 
    }

  // console.log("Renovando Token??? ");
  if (shouldRenewToken(currentToken)) {
    // console.log("Renovando Token");
    
    try {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + currentToken;
      const { data } = await axios.post('users/renew');
      
      localStorage.setItem('user', JSON.stringify(data.data.user));    
      localStorage.setItem('jwt', data.data.token);
      store.dispatch('user/setLoggedUser', {user: data.data.user});
    } catch (error) {
      console.error(error);
      return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }
  } else {
    // Configurar header sin renovar
    // console.log("paso por aqui");    
    axios.defaults.headers.common['authorization'] = 'Bearer ' + currentToken;        
    // console.log("Header configurado:", axios.defaults.headers.common['Authorization']); // ¿Se mantiene?
  }  
  // console.log("antes de next en el beforeeach: routeTo :", routeTo);
  // console.log("Llamando a next()...");
  next();
  // console.log("Después de next()"); // ¿Se ejecuta esto?
});

/**
 * Verifica si un token JWT necesita ser renovado
 * @param {string} token - Token JWT
 * @returns {boolean} - True si el token necesita renovación
 */
function shouldRenewToken(token) {
  if (!token) return true;
  
  try {
    // Decodificar el token (sin verificación de firma)
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    const payload = JSON.parse(jsonPayload);
    const expirationTime = payload.exp * 1000; // Convertir a milisegundos
    const currentTime = Date.now();
    
    // Renovar si faltan menos de 5 minutos para que expire (300000 ms)
    console.log(" expirationTime - currentTime = ", (expirationTime - currentTime));    
    return expirationTime - currentTime < 300000;
  } catch (error) {
    console.error('Error al decodificar token:', error);
    return true; // Si hay error, mejor renovar
  }
}

// router.beforeEach(async (to, from, next) => {
//   const authRequired = to.matched.some(route => route.meta.authRequired);
  
//   // Si la ruta no requiere autenticación, continuar
//   if (!authRequired) return next();

//   const token = localStorage.getItem('jwt');
  
//   // Si no hay token, redirigir al login
//   if (!token) {
//     return next({ name: 'login', query: { redirectFrom: to.fullPath } });
//   }

//   // Verificar si el token necesita renovación (ejemplo: expira en menos de 5 min)
//   const needsRenewal = shouldRenewToken(token); // Implementa esta función
  
//   if (needsRenewal) {
//     try {
//       axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//       const { data } = await axios.post('users/renew');
      
//       localStorage.setItem('user', JSON.stringify(data.data.user));    
//       localStorage.setItem('jwt', data.data.token);
//       store.dispatch('user/setLoggedUser', { user: data.data.user });
//     } catch (error) {
//       console.error("Error renovando token:", error);
//       return next({ name: 'login', query: { redirectFrom: to.fullPath } });
//     }
//   } else {
//     // Si no necesita renovación, simplemente usar el token actual
//     axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//   }

//   next(); // Continuar navegación
// });

// function shouldRenewToken(token) {
//   try {
//     const decoded = jwtDecode(token);
//     const now = Date.now() / 1000; // Tiempo actual en segundos
//     const threshold = 300; // Renovar si expira en menos de 5 minutos (300 segundos)
    
//     return (decoded.exp - now) < threshold;
//   } catch (error) {
//     console.error("Error decodificando token:", error);
//     return false;
//   }
// }

router.beforeEach((routeTo, routeFrom, next) => {
  if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {

    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

    // If auth isn't required for the route, just continue.
    if (!authRequired) return next();

    // If auth is required and the user is logged in...
    if (store.getters['auth/loggedIn']) {
      // Validate the local user token...
      return store.dispatch('auth/validate').then((validUser) => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        validUser ? next() : redirectToLogin();
      });
    }

    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    redirectToLogin();

    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-inner-declarations
    function redirectToLogin() {
      // Pass the original route to the login component
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }
  } else {
    const publicPages = ['/login', '/register', '/forgot-password'];
    const isRestorePasswordRoute = routeTo.path.startsWith('/restore-password');
    const authpage = !publicPages.includes(routeTo.path) && !isRestorePasswordRoute;
    const loggeduser = localStorage.getItem('user');
    // console.log("estamos pasando por este otro beforeeach antes de if (authpage && !loggeduser)");
    if (authpage && !loggeduser) {
      // console.log("pa tras loggeduser: ", loggeduser );
      // console.log("pa tras routeTo.path: ", routeTo.path );
      return next('/login');
    }

    next();
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // console.log("estamos pasando por este beforeResolve");
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title;
  // If we reach this point, continue resolving the route.
  next();
});

export default router;



// router.beforeEach(async (routeTo, routeFrom, next) => {
//   const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
  
//   if (!authRequired) return next();
//   axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt'); // for all requests
//   await axios.post('users/renew').then((data) => {
//     localStorage.setItem('user', JSON.stringify(data.data.user));    
//     localStorage.setItem('jwt', data.data.token);
//     store.dispatch('user/setLoggedUser', {user : data.data.user });
//     next();
//   }).catch((error) => {
//     console.log(error);
//     next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
//   });
// });